import type { Character } from "~/types/ip";
import type { CtaLink, SynopsisData } from "@laftel-ip-originals/notion/contracts";

import oneroomtaCharacters from "~/data/oneroomta/characters.json";
import oneroomtaSynopsis from "~/data/oneroomta/synopsis.json";
import oneroomtaCtaLinks from "~/data/oneroomta/cta-links.json";
import seeingdoubleCharacters from "~/data/seeingdouble/characters.json";
import seeingdoubleSynopsis from "~/data/seeingdouble/synopsis.json";
import seeingdoubleCtaLinks from "~/data/seeingdouble/cta-links.json";

interface IpPageData {
  characters: Character[];
  synopsis: SynopsisData;
  ctaLinks: CtaLink[];
}

const PAGE_DATA: Partial<Record<string, IpPageData>> = {
  seeingdouble: {
    characters: seeingdoubleCharacters as unknown as Character[],
    synopsis: seeingdoubleSynopsis as unknown as SynopsisData,
    ctaLinks: seeingdoubleCtaLinks as unknown as CtaLink[],
  },
  oneroomta: {
    characters: oneroomtaCharacters as unknown as Character[],
    synopsis: oneroomtaSynopsis as unknown as SynopsisData,
    ctaLinks: oneroomtaCtaLinks as unknown as CtaLink[],
  },
};

export function getIpPageData(slug: string | undefined): IpPageData | null {
  return slug ? (PAGE_DATA[slug] ?? null) : null;
}
